
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import { IPresentationModel } from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { canvasToPt, ptToEmu } from '@src/slide/infrastructure/module/independent/unit';
import ua from '@tencent/docs-user-agent';
import i18n from 'i18next';

/**
 * 缩放页面元素，修改 slide 比例
 */
export function changeSlideSize(currentPresentation, aiPresentation) {
    const { slideWidth, slideHeight, slideSizeType } = currentPresentation.props;
    const { slideWidth: aiSlideWidth, slideHeight: aiSlideHeight } = aiPresentation.props;
    if (slideWidth === aiSlideWidth && slideHeight === aiSlideHeight) {
        return;
    }
    const scaleX = slideWidth / aiSlideWidth;
    const scaleY = slideHeight / aiSlideHeight;
    const scale = Math.abs(scaleX - 1) > Math.abs(scaleY - 1) ? scaleX : scaleY;
    aiPresentation.updateCustomSlideSize(
        ptToEmu(canvasToPt(slideWidth)),
        ptToEmu(canvasToPt(slideHeight)),
        scale,
        slideSizeType,
    );
}

/**
 * AI 替换页面
 * @param newPresentation 新的模板 presentation
 * @param slideId 新的 slide 页的 Id
 * @param startCurrentId
 * @param uiDataService
 * @param startSlideModel
 */
export function replaceSlide(
    newPresentation: IPresentationModel,
    slideId: string,
    startCurrentId: string,
    uiDataService: IUiDataService,
    startSlideModel?: ISlideModel,
) {
    let currentSlide = startSlideModel;

    if (!currentSlide) {
        const { selectionService } = uiDataService.presentation ?? {};
        if (!selectionService) {
            return;
        }
        currentSlide = selectionService.currentSlide;
    }
    if (!currentSlide) return;

    const currentSlideIndex = uiDataService.presentation.indexOfSlide(currentSlide);

    // 协同锁
    const lockManager = OnlineEditServices.CooperationLockManager();
    const lockInfo = lockManager?.getLockInfoByIndex(
        currentSlideIndex,
        currentSlide.type,
    );
    if (lockInfo && !lockInfo.user.isSelf) {
        showSnackbar({ message: i18n.t('此页正在被编辑中，请稍后再试') });
        return;
    }

    if (currentSlide?.getAIType() === 3 || currentSlide?.getAIType() === 'page') {
        // 正文页只需替换 slide
        const slideToReplace = newPresentation.children.find(i => i.id === slideId);
        uiDataService?.presentation.replaceSlideToSelectedIndex([slideToReplace], startCurrentId, startSlideModel);
        return;
    }
    // 其他页需要替换 presentation
    uiDataService?.presentation.replacePresentationToSelectedIndex(
        newPresentation, slideId,
        startCurrentId, startSlideModel,
    );
}

function showSnackbar(configs): void {
    try {
        if (ua.isMobile) {
            import('@tencent/dui-mobile/lib/components/Snackbar').then((obj) => {
                const SnackbarMobile = obj.default;
                SnackbarMobile.show(configs);
            });
        } else {
            import('@tencent/dui/lib/components/Snackbar').then((obj) => {
                const Snackbar = obj.default;
                Snackbar.show(configs);
            });
        }
    } catch (error) {
        window.log.error(`[loadChunk-error]${error}`);
    }
}
